import { render as footerRenderer, IFooterConfig } from '@umu/home-footer';
import { render as headerRenderer, IHeaderConfig } from '@umu/home-header';
import { initHeader } from '@umu/umu-common-header';
import ThemeConfigProvider from 'common/src/config/theme/themeConfig';
import { createRoot } from 'react-dom/client';

import 'businessCommon/src/styles/businessCommon.scss';
import { langOptions } from 'common/const';
import 'common/src/styles/common.scss';
import { getMenuData } from 'plan/@planPricing/service/getMenuData';
import CommercializePage from 'src/common/page';
import { App } from './app';
import { IWhitePaper } from './interface/pageData';
import { getAppData } from './service/whitePaper';
import './whitePaper.scss';

class WhitePaper extends CommercializePage<IWhitePaper> {
    constructor() {
        super(getAppData());
        this.render();
    }
    public getInitState() {
        const state = {
            pageData: {
                contextInfo: getAppData('contextInfo'),
                userInfo: getAppData('userInfo') || {},
                referUrl: getAppData('refer_url'),
            },
        };
        return state;
    }

    public async render() {
        const store = this.getInitState();
        const pageData = store.pageData;
        const userInfo = pageData.userInfo;
        const siteHost = getAppData('siteHost');
        const LANG = getAppData('Lang');
        const SYSTEM = getAppData('SYSTEM');

        if (userInfo.umu_id && +userInfo.umu_id > 0) {
            initHeader({
                userInfo: pageData.userInfo as any,
                siteHost: siteHost,
                lang: LANG,
                system: SYSTEM,
            });
        } else {
            const config = {
                siteHost: siteHost,
                platform: 'twww',
                system: SYSTEM.toLocaleUpperCase(),
                lang: window.langMap[LANG as 'zh-cn'],
                headerData: (await getMenuData()).header,
                langOptions,
            };
            headerRenderer(config as IHeaderConfig, document.querySelector('#common-header') as HTMLElement);
        }

        footerRenderer(
            {
                siteHost,
                platform: 'twww',
                system: SYSTEM.toLowerCase(),
                lang: window.langMap[LANG as 'zh-cn'],
                langOptions,
                footerData: (await getMenuData()).footer,
            } as IFooterConfig,
            document.querySelector('#common-footer') as HTMLElement,
        );

        createRoot(document.querySelector('.doc-wide')!).render(
            <ThemeConfigProvider>
                <div>
                    <App referUrl={pageData.referUrl}></App>
                </div>
            </ThemeConfigProvider>,
        );
    }
}
export default new WhitePaper();
